import {ORDER_BASE_PATH} from "../const/routes";

/**
 * Továrna URL.
 *
 * Jednoduché statické metody vracející pouze String - URL.
 */
export default class ObjednavkyUrlFactory {
    /**
     * URL pro stránku detailu objednávky.
     * @param id ID objednávky
     * @return {string}
     */
    static objednavkaDetail(id) {
        return `/${ORDER_BASE_PATH}/${id}`;
    }

    /**
     * URL pro stránku potvrzení odeslání objednávky.
     * @param id ID objednávky
     * @returns {string}
     */
    static objednavkaConfirm(id) {
        return `/${ORDER_BASE_PATH}/${id}/potvrzeni`;
    }
}
